import React, { useEffect, useState } from 'react'
import swal from "sweetalert"
import { Link, useHistory } from "react-router-dom"
import { Button, Col, Dropdown, DropdownButton, FormControl, InputGroup, Row, Form } from "react-bootstrap"
import { AddIconOutline, MenuDots, SearchIcon } from "../../components/SvgIcons"
import { toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import BarLoader from "react-spinners/BarLoader";
import { constants, customStyles } from "../../utils/constants";
import { DeleteUser, GetUsers } from "../../services/users.service";
import { EmptyLocalStorage } from "../../services/auth/auth.service";
import { DeletePushNotification, GetPushNotification } from "../../services/pushnotification.service";
import { FaCheck, FaTimes } from 'react-icons/fa'
import moment from "moment";

function ListPushNotification() {
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(constants.PERPAGE);
    const [rows, setRows] = useState();
    const [keyword, setKeyword] = useState('');



    const getPushNotification = async () => {
        setLoading(true)
        await GetPushNotification(page, perPage).then((result) => {
            if (result.status) {
                if (result?.data?.data) {
                    const rowData = [];
                    const startIndex = (page - 1) * perPage;

                    setPage(result?.data?.pagination?.currentPage)
                    setTotalRows(result.data?.pagination?.total);
                    result?.data?.data.map((dt, index) => {
                        rowData.push({
                            serialNumber: startIndex + index + 1,
                            id: dt._id || '-',
                            title: dt.title || '-',
                            message: dt.message || '-',
                            createdAt: moment(dt.createdAt).fromNow() || '-',
                            users: dt.users
                                ? dt.users.map(user => ({
                                    id: user._id || '-',
                                    fullName: user.fullName || '-',
                                    email: user.email || '-',
                                    profileImage: user.profileImage || '-'
                                }))
                                : [],
                            userCount: dt?.users.length
                        });

                    })
                    setRows(rowData);
                    setLoading(false)
                }
            } else {
                setLoading(false)
                return toast.error(result.message);
            }
        }).catch((error) => {
            setLoading(false)
            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else {
                return toast.error(error.response.data.message);
            }
        })
    }

    useEffect(async () => {
        getPushNotification();
    }, [page, perPage])


    const onUserDelete = (id) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to delete this user?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willShip) => {
            //Delete  API
            if (willShip) {
                await DeletePushNotification(id).then((result) => {
                    if (result.status) {
                        swal(result.message, {
                            icon: "success",
                        });
                        getPushNotification();
                    } else {
                        toast.error(result.message);
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        EmptyLocalStorage()
                        history.push('/');
                    } else {
                        return toast.error(error.response.data.message);
                    }
                })
            }
        });
    }

    const onEdit = (data) => {
        history.push('/manage-users/edit-user/' + data.id, {
            data: data
        });
    }



    const userActions = (data) => {
        return (
            <DropdownButton align="end" className={"actionDropdown"} id="dropdown-item-button" title={<MenuDots />}>
                <Dropdown.Item as="button" onClick={() => history.push(`/notification/details/${data.id}`)}>
                    View Details
                </Dropdown.Item>
                {/* <Dropdown.Item as="button" onClick={() => onUserDelete(data.id)}>Delete</Dropdown.Item> */}
            </DropdownButton>
        )
    }

    const columns = [
        {
            id: 'serialNumber',
            name: 'S.NO',
            maxWidth: '60px',
            center: true,
            // sortable: true,
            selector: rowData => rowData.serialNumber,
        },
        // {
        //     id: 'type',
        //     name: 'Type',
        //     maxWidth: '80px',
        //     center: true,
        //     sortable: true,
        //     selector: rowData => rowData.type,
        // },
        {
            id: 'title',
            name: 'Title',
            maxWidth: '140px',
            // center: true,
            selector: rowData => rowData.title,
        },
        {
            id: 'message',
            name: 'Message',
            maxWidth: '250px',
            selector: rowData => rowData.message,
        },
        {
            id: 'user-count',
            name: 'Number of Users',
            // maxWidth: '60px',
            center: true,
            selector: rowData => rowData.userCount,
        },
        {
            id: 'createdAt',
            name: 'Created At',
            // maxWidth: '140px',
            center: true,
            selector: rowData => rowData.createdAt,
        },
        // {
        //     id: 'created_at ',
        //     name: 'Created At ',
        //     minWidth: '140px',
        //     center: true,
        //     selector: rowData => rowData.created_at,
        // },
        {
            id: 'action',
            name: 'Action',
            center: true,
            cell: rowData => userActions(rowData)
        },
    ];

    return (
        <div className={"usersPage"}>
            {/*<h1 className="page-heading">Users ({totalRows})</h1>*/}
            <h1 className="page-heading">Notifications</h1>
            <hr />
            <div className={"customOrderFilters"}>
                <Row>
                    {/* <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                        <InputGroup className="mb-3 search-group">
                            <InputGroup.Text id="basic-addon1"><SearchIcon /></InputGroup.Text>
                            <FormControl
                                placeholder="Search"
                                aria-label="Search"
                                aria-describedby="Search"
                                maxLength={"255"}
                                onChange={(e) => {
                                    (e.target.value.length > 2) ? setKeyword(e.target.value) : setKeyword(null)
                                }}
                            />
                        </InputGroup>
                    </Col> */}
                    <Col xs={12} sm={12} md={5} lg={5} xl={5}></Col>
                    <Col xs={12} sm={12} md={{ span: 2, offset: 2 }} lg={{ span: 2, offset: 2 }} xl={{ span: 2, offset: 2 }}>

                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3} xl={3}>
                        <Link to={"/notification"}>
                            <Button className={"btn btn-green-theme h40 w-100 mb-3"}>
                                <AddIconOutline /> Send Notification
                            </Button>
                        </Link>
                    </Col>
                </Row>

            </div>
            <div className="theme-dataGrid products-dataGrid">
                <DataTable
                    pagination
                    columns={columns}
                    data={rows}
                    // actions={actionsMemo}
                    // data={data}
                    progressPending={loading}
                    customStyles={customStyles}
                    selectableRows={false}
                    striped
                    highlightOnHover

                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={perPage}
                    onChangePage={(page) => {
                        setPage(page);
                    }}
                    onChangeRowsPerPage={(currentRowsPerPage) => {
                        setPerPage(currentRowsPerPage)
                    }}
                    progressComponent={<BarLoader color={'#41D2D2'} loading={loading} css={'marginTop: 10px'}
                        height={'4'} width={'100%'} />}
                />
            </div>
        </div>
    )
}

export default ListPushNotification
